import { useState, useEffect } from 'react';
import { AlertTriangle, X, ExternalLink } from 'lucide-react';
import demoService from '../../services/demoService';

/**
 * Demo Mode Banner
 * Shows a dismissible banner when the application is running in demo mode
 */
export function DemoBanner() {
  const [isDemoMode, setIsDemoMode] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkDemoMode = async () => {
      try {
        const isDemo = await demoService.isDemoMode();
        setIsDemoMode(isDemo);
      } catch (error) {
        console.error('Error checking demo mode:', error);
      } finally {
        setLoading(false);
      }
    };

    checkDemoMode();
  }, []);

  if (loading || !isDemoMode || !isVisible) {
    return null;
  }

  return (
    <div className="bg-gradient-to-r from-amber-500 to-orange-500 text-white px-4 py-2 shadow-md">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center gap-3">
          <AlertTriangle className="w-5 h-5 flex-shrink-0" />
          <div className="text-sm">
            <span className="font-semibold">Demo-Modus aktiv</span>
            <span className="hidden sm:inline ml-2">
              – E-Mail-Versand und Lexoffice-Synchronisation sind deaktiviert.
            </span>
          </div>
        </div>
        
        <div className="flex items-center gap-3">
          <a 
            href="https://easywork-bi.de/kontakt" 
            target="_blank" 
            rel="noopener noreferrer"
            className="hidden sm:flex items-center gap-1 text-sm bg-white/20 hover:bg-white/30 px-3 py-1 rounded-full transition-colors"
          >
            Vollzugang anfragen
            <ExternalLink className="w-3.5 h-3.5" />
          </a>
          
          <button 
            onClick={() => setIsVisible(false)}
            className="p-1 hover:bg-white/20 rounded transition-colors"
            aria-label="Banner schließen"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
}

export default DemoBanner;
